import Echarts from "echarts";
import getJson from "@/method";
const color = ['#C4BD97', '#F79646', '#FF2500', '#C01900', '#92D050', '#000000', '#45A1B9', '#98747F', '#3DCFC5', '#62AAA3', '#6AF910', '#948A54', '#984808', '#9F2397', '#B3A2C7'];


export const setKarte = ({
    dataX, dataY, id, title, yAxis, axisLabel
}, isOnResize) => {
    const myChart = Echarts.init(document.getElementById(id));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        title: {
            text: title
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
        },
        grid: {
            top: 120,
        },
        legend: {
            top: 30,
            data: dataY.map(x => x.name)
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    show: true
                }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14,
                    ...axisLabel
                },
                data: dataX || ['5/1', '5/2', '5/3', '5/4', '5/5', '5/6', '5/7']
            }
        ],
        yAxis: yAxis || [
            {
                type: 'value',
                name: '',
                axisLabel: {
                    formatter: '{value}'
                },

            },
            {
                type: 'value',
                name: '',
                axisLabel: {
                    formatter: '{value} %'
                }
            }
        ],
        series: dataY.map((x, i) => {
            return {
                name: x.name,
                type: x.type && x.type == 'percent' ?
                    "line" : 'bar',
                data: x.data,
                yAxisIndex: x.type === "percent" ? 1 : 0,
            }
        }),
    }

    myChart.setOption(option);
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/regionalReport/mayDay/compute.js